import { action, observable } from "mobx";
import Tax from "~/models/Invoice/Tax";
import TaxRepository from "~/repository/Invoice/TaxRepository";
import NestStore from "../NestStore";

class TaxStore extends NestStore {
  rootStore = null;

  /**
   * @property {Array}
   */
  @observable taxes = [];

  /**
   * @property {Tax}
   */
  @observable tax;

  taxRepository = null;

  constructor(rootStore) {
    super();

    this.rootStore = rootStore;

    this.taxRepository = new TaxRepository();

    this.setDefaultSearchParams();
  }

  @action
  loadIndex() {
    this.isLoading = true;

    return Promise.all([this.getAll()]).finally(() => {
      this.isLoading = false;
    });
  }

  /**
   * Get all.
   */
  @action
  getAll() {
    const params = {
      offset: this.offset,
      limit: this.pagination.itemsPerPage,
    };

    if (this.searchParams.state !== "") {
      params.state = this.searchParams.state;
    }

    if (this.searchParams.country !== "") {
      params.country = this.searchParams.country;
    }

    params.isActive = 1;

    return this.taxRepository.fetch(params).then(response => {
      this.processEntities(response.data.taxes);
      this.processPagination(response.data.pagination);
    });
  }

  @action
  processEntities(taxes = []) {
    this.taxes = [];

    taxes.forEach(taxArray => {
      const tax = new Tax(taxArray);

      this.taxes.push(tax);
    });
  }

  /**
   * Set default search params.
   */
  @action
  setDefaultSearchParams() {
    this.searchParams.state = "";
    this.searchParams.country = "";
  }

  /**
   * Calculate tax amount
   *
   * @param subTotal
   * @param tax
   */
  calculateTaxAmount(subTotal, tax) {
    return Math.round(subTotal * tax.rate) / 100;
  }
}

export default TaxStore;
